<template>
   <div class="view-cohort-details container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Perc cursor-pointer" v-on:click="udpateCloseViewCohortDetailOverlay($event)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Cohort Name:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{CohortNameValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Group Name:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{GroupNameValue}}
                </div> 
                <div class="col-md-1 col-lg-1">
                </div> 
              </div>
              <div class="row vertical-align margin-bottom-2Perc"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Course Name:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{CourseNameValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div v-if="showRecommendedActionUIValue">
                <hr width="94%" size="10px"/>
                <div class="row vertical-align margin-bottom-2Perc">
                  <div class="row col-md-1 col-lg-1"></div>
                  <div class="row col-md-6 col-lg-6 create-lesson-input-text-style font-size-17px text-align-left">
                    <span><b>Found Recommended Action Setup: </b></span><span>{{ (recommendActionsDataValue.length) }}</span>
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12">
                      </div>
                    </div>
                  </div>
                  <div class="row col-md-3 col-lg-3"></div>
                </div>

                <div class="row margin-bottom-2Perc vertical-align" v-if="(recommendActionsDataValue.length > 0)">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                    <div class="table-responsive margin-Top-3Perc" >
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-align-center font-size-15px border-right">SR. No.</th>
                            <th class="text-align-center font-size-15px">Number of scheduled user meeting(s)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(currObj, index) in recommendActionsDataValue" :key="'view_recommended_action_' + index">
                            <td class="border-right text-align-center col-lg-1">{{(index + 1)}}</td>
                            <td class="text-align-center col-lg-11">{{getCurrentCondition(currObj)}}</td>       
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>
                <hr width="94%" size="10px"/>
              </div>

              <div class="row vertical-align margin-bottom-2Perc"> 
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Created TS:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{formatAndShowDate(CreatedTSValue)}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="udpateCloseViewCohortDetailOverlay($event)">Done</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
    </div> 
</template>
<script>
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { constants } from '../utils/constants'
export default {
  props: ['cohortObj', 'groupCourseObj'],
  name: 'view-cohort-details',
  created () {},
  data: function () {
    return {
      constants: constants
    }
  },
  components: {},
  methods: {
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    udpateCloseViewCohortDetailOverlay: function (event) {
      this.$emit('updateDetailsOverlayFlag', false)
    },
    getCurrentCondition: function (currObj) {
      var valueToReturn = ''
      valueToReturn = ''
      switch (currObj.ConditionOperator) {
        case constants.RecommendActionOperatorEnum.None:
        default:
          valueToReturn += ' Not Found '
          break
        case constants.RecommendActionOperatorEnum.LessThan:
          valueToReturn += ' Less than '
          break
        case constants.RecommendActionOperatorEnum.LessThanEqual:
          valueToReturn += ' Less than or Equals to '
          break
        case constants.RecommendActionOperatorEnum.GreaterThan:
          valueToReturn += ' Greater than '
          break
        case constants.RecommendActionOperatorEnum.GreaterThanEqual:
          valueToReturn += ' Greater than or Equals to '
          break
        case constants.RecommendActionOperatorEnum.EqualTo:
          valueToReturn += ' Equals to '
          break
      }
      valueToReturn += currObj.NumberofMeetings + ' then return '
      valueToReturn += currObj.ReturnActionCount + ' action' + (currObj.ReturnActionCount > 1 ? 's' : '')
      return valueToReturn
    }
  },
  computed: {
    showRecommendedActionUIValue: {
      get: function () {
        return (this.groupCourseObj.CourseMasterId === constants.Default_Meeting_Mentor_Course)
      }
    },
    recommendActionsDataValue: {
      get: function () {
        return (this.cohortObj.RecommendActionsData !== undefined && this.cohortObj.RecommendActionsData !== 'undefined' && this.cohortObj.RecommendActionsData !== null && this.cohortObj.RecommendActionsData !== 'null' && this.cohortObj.RecommendActionsData !== '' && this.cohortObj.RecommendActionsData.length !== 0) ? JSON.parse(this.cohortObj.RecommendActionsData) : []
      }
    },
    CohortNameValue: {
      get: function () {
        return this.cohortObj.CohortName
      }
    },
    GroupNameValue: {
      get: function () {
        return this.groupCourseObj.GroupName
      }
    },
    CourseNameValue: {
      get: function () {
        return this.groupCourseObj.CourseTitle
      }
    },
    CreatedTSValue: {
      get: function () {
        return this.cohortObj.CreatedTS
      }
    },
    StartTSValue: {
      get: function () {
        return this.cohortObj.StartTS
      }
    },
    EndTSValue: {
      get: function () {
        return this.cohortObj.EndTS
      }
    }
  }
}
</script>

<style scoped>
.Padding-right-0Px {
  padding-right: 0px;
}
.padding-left-0Perc {
  padding-left: 0px;
}
.font-size-12px {
  font-size: 12px;
}
.font-size-15px {
  font-size: 15px;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-decoration-underline {
  text-decoration: underline;
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.text-align-center
{
  text-align: center;
}

.overlay-content {
  position: relative;
  top: 23%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ViewCohortDetailsOverlay.vue